export default __webpack_public_path__ + "static/andrea-bellomia-89237f5dd6cac2a099b685122dd53644.jpg";